import { getRequest, postRequest } from '@bo-apis/axios';

const getMember = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-member`,
  });

const getMemberList = ({ form, pageable }) =>
  postRequest({
    url: 'api/v1/member/get-member-list',
    params: { ...pageable },
    data: { ...form },
  });

const getMemberAdditionalInfo = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-additional-info`,
  });

const getMemberUnusualItemList = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-unusual-item-list`,
  });

const getMemberDeliveryLocationList = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-location-list`,
  });

const saveMemberDetailData = (memberNumber, saveData) =>
  postRequest({
    url: `api/v1/member/${memberNumber}/save-detail-data`,
    data: { ...saveData },
  });

const issueTempPassword = (payload) =>
  postRequest({
    url: `api/v1/member/issue-temp-password`,
    data: { ...payload },
  });

const getCounselingMemberInfo = (loginId, cellNumber) =>
  postRequest({
    url: `api/v1/member/find-counseling-member-info`,
    data: { loginId, cellNumber },
  });

const getMemberDisplayingUnusualItemList = (memberNumber) =>
  getRequest({
    url: `api/v1/member/${memberNumber}/get-displaying-unusual-item-list`,
  });

const createMemberList = (payload) =>
  postRequest({
    url: `api/v1/member/save-member-list`,
    data: payload,
  });

const updateMemberLoginFailCnt = (payload) =>
  postRequest({
    url: `api/v1/member/update-member-login-fail-cnt`,
    data: payload,
  });

const updateCheckNameExcept = (payload) => 
postRequest({
  url: `api/v1/member/update-member-check-name-except`,
  data: payload,
});

export default {
  getMember,
  getMemberList,
  getMemberAdditionalInfo,
  getMemberDeliveryLocationList,
  getMemberUnusualItemList,
  saveMemberDetailData,
  issueTempPassword,
  getCounselingMemberInfo,
  getMemberDisplayingUnusualItemList,
  createMemberList,
  updateMemberLoginFailCnt,
  updateCheckNameExcept,
};
